import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';

import { messages } from '../../../messages';

import type { PickListGridItem } from '../pick-list-grid';

type LastModifiedByCellProps = {
  row: { original: PickListGridItem };
};

const LastModifiedByCell = ({ row }: LastModifiedByCellProps) => {
  const { modifiedBy } = row.original;
  if (!modifiedBy) {
    return null;
  }
  return <Text shouldTruncate textType={TextType.Paragraph} value={modifiedBy} />;
};

export const createLastModifiedByColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'modifiedBy',
  Header: <FormattedMessage {...messages.gridColLastModified} />,
  Cell: LastModifiedByCell,
  width: 1.75,
});
